import React from "react";
import { Phone, Mail } from "lucide-react";
import { useSitePhone } from "@/hooks/useSitePhone";
import { useLocation } from "react-router-dom";
import { isLandingRoute } from "@/components/SiteHeader";
import { useFloatingControlGuard } from "@/hooks/useFloatingControlGuard";

const StickyMobileCTA = () => {
  const { phone, phoneLink } = useSitePhone();
  const { pathname } = useLocation();
  const landing = isLandingRoute(pathname);
  const { ref, obstructed } = useFloatingControlGuard();

  const scrollToForm = (e: React.MouseEvent) => {
    e.preventDefault();
    const targets = [
      "#service-form",
      "#quote-mobile",
      "#quote-desktop",
      "#estimate",
      "#estimate-form-top",
      "form",
    ];

    for (const selector of targets) {
      const el = document.querySelector(selector);
      if (el) {
        el.scrollIntoView({ behavior: "smooth", block: "start" });
        return;
      }
    }
  };

  return (
    <div
      ref={ref}
      aria-hidden={obstructed}
      data-sticky-cta
      className={`fixed bottom-0 left-0 right-0 z-50 md:hidden border-t border-accent/40 shadow-[0_-8px_24px_-8px_rgba(0,0,0,0.6)] ${obstructed ? "invisible pointer-events-none" : "visible"}`}
      style={{
        backgroundColor: "#1A1A1A",
        paddingBottom: "env(safe-area-inset-bottom, 0px)",
      }}
    >
      <div className="flex gap-2 p-2">
        <a
          id="callnowbutton"
          href={phoneLink}
          className="flex-1 flex flex-col items-center justify-center rounded-xl font-bold text-primary
                     bg-gradient-to-r from-accent to-accent-light touch-manipulation
                     active:brightness-90 transition-all"
          style={{ minHeight: "56px", lineHeight: 1.15 }}
          aria-label={`Call ${phone} now for electrical service`}
        >
          <span className="flex items-center gap-2 text-[15px]">
            <Phone className="w-[18px] h-[18px]" aria-hidden="true" />
            Call Now
          </span>
          <span className="text-[11px] font-semibold opacity-80">{phone}</span>
        </a>

        <a
          href="#quote"
          onClick={scrollToForm}
          className="flex-1 flex items-center justify-center gap-1.5 rounded-xl font-semibold text-[13px] leading-tight text-center px-2
                     border-2 border-accent text-accent touch-manipulation active:bg-accent/15 transition-all whitespace-normal"
          style={{ minHeight: "56px" }}
          aria-label="Request service or assessment"
        >
          <Mail className="w-[18px] h-[18px] shrink-0" aria-hidden="true" />
          {landing ? "Request Service or Assessment" : "Request Service or Assessment"}
        </a>
      </div>
    </div>
  );
};

export default StickyMobileCTA;
